function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllTobacco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "251.25pt",
    height: "75pt",
    viewBox: "0 0 251.25 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,88.235294%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 22.574219 37.222656 C 31.671875 32.773438 21 20.519531 34.628906 9.128906 C 44.445312 0.9375 54.824219 5.25 59.953125 8.183594 C 65.277344 11.3125 71.789062 11.640625 77.398438 9.066406 L 78.816406 8.421875 C 93.492188 1.648438 110.40625 1.695312 125.039062 8.550781 L 134.707031 12.992188 L 134.707031 12.988281 C 138.542969 14.792969 142.878906 15.234375 147 14.25 C 150.460938 13.449219 154.078125 13.652344 157.433594 14.828125 C 164.242188 17.117188 173.507812 18.578125 175.171875 11.589844 C 176.835938 4.597656 184.5 -3.082031 199.253906 2.65625 C 203.570312 4.363281 208.121094 5.402344 212.753906 5.730469 L 226.15625 6.382812 C 233.785156 6.757812 239.484375 13.328125 238.5625 20.679688 C 237.953125 25.539062 237.984375 31.066406 239.726562 36.136719 C 242.515625 44.25 233.410156 48.089844 233.667969 53.558594 C 234.132812 63.496094 224.667969 73.464844 203.808594 72.015625 L 203.804688 72.015625 C 197.484375 71.53125 191.3125 69.847656 185.617188 67.058594 C 179.054688 63.910156 167.242188 59.867188 156.695312 64.808594 L 152.898438 65.867188 L 152.902344 65.863281 C 145.117188 68.023438 136.917969 68.207031 129.046875 66.390625 L 126 65.683594 C 115.339844 63.230469 104.160156 64.453125 94.28125 69.15625 L 11.03125 69.15625 C 21.683594 57.480469 8.378906 44.160156 22.574219 37.222656 Z M 22.574219 37.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 104.664062 70.261719 L 6.382812 70.261719 C 5.96875 70.261719 5.632812 69.925781 5.632812 69.511719 C 5.632812 69.097656 5.96875 68.761719 6.382812 68.761719 L 104.632812 68.761719 C 105.046875 68.761719 105.382812 69.097656 105.382812 69.511719 C 105.382812 69.925781 105.046875 70.261719 104.632812 70.261719 Z M 104.664062 70.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.910156 37.734375 L 115.863281 34.335938 L 138.347656 53.875 L 135.394531 57.273438 Z M 112.910156 37.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 112.90625 37.734375 L 114.230469 36.210938 L 136.714844 55.75 L 135.390625 57.273438 Z M 112.90625 37.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 112.910156 37.726562 L 115.863281 34.328125 L 120.660156 38.496094 L 117.707031 41.894531 Z M 112.910156 37.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 112.90625 37.726562 L 114.230469 36.203125 L 119.027344 40.371094 L 117.703125 41.894531 Z M 112.90625 37.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 115.859375 34.335938 L 138.359375 53.875 L 135.40625 57.273438 L 112.90625 37.773438 L 115.859375 34.375 M 115.859375 32.875 L 115.753906 32.875 L 115.753906 32.871094 C 115.359375 32.898438 114.988281 33.082031 114.726562 33.382812 L 111.75 36.75 C 111.488281 37.050781 111.355469 37.445312 111.382812 37.84375 C 111.410156 38.242188 111.597656 38.613281 111.898438 38.871094 L 134.398438 58.410156 C 135.027344 58.953125 135.972656 58.886719 136.515625 58.261719 L 139.5 54.855469 C 140.042969 54.230469 139.976562 53.28125 139.351562 52.738281 L 116.851562 33.238281 C 116.578125 33.003906 116.230469 32.871094 115.867188 32.871094 Z M 115.859375 32.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 216.257812 14.242188 L 218.5625 10.378906 L 244.230469 25.691406 L 241.925781 29.554688 Z M 216.257812 14.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 216.261719 14.242188 L 217.296875 12.507812 L 242.957031 27.816406 L 241.921875 29.550781 Z M 216.261719 14.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 216.253906 14.242188 L 218.558594 10.378906 L 224.035156 13.644531 L 221.730469 17.507812 Z M 216.253906 14.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 216.25 14.238281 L 217.285156 12.503906 L 222.761719 15.769531 L 221.726562 17.503906 Z M 216.25 14.238281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 218.574219 10.386719 L 244.238281 25.695312 L 241.929688 29.566406 L 216.261719 14.25 L 218.570312 10.386719 M 218.570312 8.886719 L 218.574219 8.886719 C 218.039062 8.890625 217.550781 9.175781 217.28125 9.636719 L 214.980469 13.5 C 214.773438 13.84375 214.714844 14.25 214.808594 14.640625 C 214.90625 15.027344 215.15625 15.359375 215.496094 15.5625 L 241.160156 30.871094 L 241.164062 30.871094 C 241.386719 31.011719 241.648438 31.085938 241.914062 31.085938 C 242.445312 31.085938 242.9375 30.796875 243.203125 30.335938 L 245.503906 26.472656 L 245.503906 26.476562 C 245.929688 25.765625 245.695312 24.84375 244.988281 24.421875 L 219.335938 9.097656 C 219.109375 8.960938 218.851562 8.886719 218.585938 8.886719 Z M 218.570312 8.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 198.5 65.09375 L 223.128906 48.160156 L 225.679688 51.867188 L 201.050781 68.800781 Z M 198.5 65.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 199.914062 67.148438 L 224.535156 50.21875 L 225.679688 51.882812 L 201.058594 68.8125 Z M 199.914062 67.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 198.503906 65.097656 L 203.757812 61.484375 L 206.308594 65.191406 L 201.054688 68.804688 Z M 198.503906 65.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 199.910156 67.144531 L 205.164062 63.53125 L 206.308594 65.195312 L 201.054688 68.808594 Z M 199.910156 67.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 223.125 48.15625 L 225.675781 51.859375 L 201.046875 68.796875 L 198.496094 65.09375 L 223.125 48.15625 M 223.125 46.65625 C 222.820312 46.65625 222.523438 46.746094 222.269531 46.921875 L 197.648438 63.855469 C 196.964844 64.324219 196.796875 65.257812 197.265625 65.941406 L 199.816406 69.644531 C 200.039062 69.972656 200.382812 70.199219 200.773438 70.273438 C 200.863281 70.28125 200.957031 70.28125 201.046875 70.273438 C 201.351562 70.277344 201.648438 70.183594 201.898438 70.011719 L 226.5 53.101562 C 227.179688 52.628906 227.351562 51.695312 226.882812 51.015625 L 224.332031 47.3125 L 224.332031 47.308594 C 224.109375 46.980469 223.761719 46.753906 223.371094 46.679688 C 223.28125 46.671875 223.191406 46.671875 223.101562 46.679688 Z M 223.125 46.65625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.121094 18.144531 L 154.917969 7.160156 L 156.570312 11.34375 L 128.773438 22.328125 Z M 127.121094 18.144531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 128.039062 20.464844 L 155.828125 9.484375 L 156.570312 11.359375 L 128.78125 22.339844 Z M 128.039062 20.464844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 127.128906 18.148438 L 133.058594 15.804688 L 134.710938 19.988281 L 128.78125 22.332031 Z M 127.128906 18.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 128.039062 20.457031 L 133.96875 18.113281 L 134.710938 19.988281 L 128.78125 22.332031 Z M 128.039062 20.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 154.921875 7.171875 L 156.570312 11.355469 L 128.773438 22.335938 L 127.125 18.152344 L 154.921875 7.171875 M 154.921875 5.671875 C 154.730469 5.671875 154.542969 5.707031 154.363281 5.773438 L 126.613281 16.753906 C 126.242188 16.902344 125.945312 17.1875 125.785156 17.554688 C 125.628906 17.917969 125.621094 18.335938 125.765625 18.703125 L 127.414062 22.886719 L 127.417969 22.890625 C 127.644531 23.464844 128.199219 23.84375 128.820312 23.84375 C 129.007812 23.839844 129.195312 23.804688 129.367188 23.730469 L 157.125 12.75 C 157.890625 12.445312 158.265625 11.574219 157.964844 10.808594 L 156.316406 6.625 L 156.316406 6.621094 C 156.167969 6.25 155.878906 5.953125 155.511719 5.796875 C 155.324219 5.714844 155.125 5.671875 154.921875 5.671875 Z M 154.921875 5.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,27.843137%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 52.898438 16.253906 L 88.148438 16.253906 L 88.148438 70.035156 C 88.148438 70.742188 87.574219 71.316406 86.863281 71.316406 L 54.1875 71.316406 C 53.480469 71.316406 52.90625 70.742188 52.90625 70.035156 L 52.90625 16.253906 Z M 52.898438 16.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(57.647059%,22.745098%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 52.898438 31.066406 L 88.148438 31.066406 L 88.148438 70.066406 C 88.148438 70.773438 87.574219 71.347656 86.863281 71.347656 L 54.1875 71.347656 C 53.480469 71.347656 52.90625 70.773438 52.90625 70.066406 L 52.90625 31.066406 Z M 52.898438 31.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 88.148438 31.066406 L 88.148438 70.066406 C 88.148438 70.777344 87.570312 71.355469 86.859375 71.355469 L 54.1875 71.355469 C 53.476562 71.355469 52.898438 70.777344 52.898438 70.066406 L 52.898438 31.066406 L 88.148438 31.066406 M 88.148438 30.316406 L 52.898438 30.316406 C 52.484375 30.316406 52.148438 30.652344 52.148438 31.066406 L 52.148438 70.066406 C 52.148438 70.605469 52.363281 71.125 52.746094 71.507812 C 53.128906 71.890625 53.644531 72.105469 54.1875 72.105469 L 86.859375 72.105469 C 87.398438 72.105469 87.917969 71.890625 88.300781 71.507812 C 88.683594 71.125 88.898438 70.605469 88.898438 70.066406 L 88.898438 31.066406 C 88.898438 30.867188 88.820312 30.675781 88.679688 30.535156 C 88.539062 30.394531 88.347656 30.316406 88.148438 30.316406 Z M 88.148438 30.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.957031 21.195312 L 85.246094 21.195312 L 85.246094 67.484375 L 79.957031 67.484375 Z M 79.957031 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 79.957031 21.203125 L 82.328125 21.203125 L 82.328125 67.492188 L 79.957031 67.492188 Z M 79.957031 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 79.957031 21.195312 L 85.246094 21.195312 L 85.246094 31.074219 L 79.957031 31.074219 Z M 79.957031 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 79.957031 21.203125 L 82.328125 21.203125 L 82.328125 31.074219 L 79.957031 31.074219 Z M 79.957031 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 85.253906 21.195312 L 85.253906 67.5 L 79.957031 67.5 L 79.957031 21.195312 L 85.253906 21.195312 M 85.253906 20.445312 L 79.957031 20.445312 C 79.542969 20.445312 79.207031 20.78125 79.207031 21.195312 L 79.207031 67.5 C 79.207031 67.699219 79.285156 67.890625 79.425781 68.03125 C 79.566406 68.171875 79.757812 68.25 79.957031 68.25 L 85.253906 68.25 C 85.449219 68.25 85.636719 68.171875 85.777344 68.03125 C 85.921875 67.890625 86 67.699219 86.003906 67.5 L 86.003906 21.195312 C 86.003906 20.996094 85.921875 20.804688 85.78125 20.664062 C 85.640625 20.523438 85.453125 20.445312 85.253906 20.445312 Z M 85.253906 20.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 73.921875 21.195312 L 79.210938 21.195312 L 79.210938 61.824219 L 73.921875 61.824219 Z M 73.921875 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 73.921875 21.203125 L 76.292969 21.203125 L 76.292969 61.824219 L 73.921875 61.824219 Z M 73.921875 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 73.921875 21.195312 L 79.210938 21.195312 L 79.210938 31.074219 L 73.921875 31.074219 Z M 73.921875 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 73.921875 21.203125 L 76.292969 21.203125 L 76.292969 31.074219 L 73.921875 31.074219 Z M 73.921875 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 79.207031 21.195312 L 79.207031 61.824219 L 73.957031 61.824219 L 73.957031 21.195312 L 79.207031 21.195312 M 79.207031 20.445312 L 73.957031 20.445312 C 73.542969 20.445312 73.207031 20.78125 73.207031 21.195312 L 73.207031 61.824219 C 73.207031 62.019531 73.285156 62.210938 73.425781 62.351562 C 73.566406 62.492188 73.757812 62.574219 73.957031 62.574219 L 79.207031 62.574219 C 79.40625 62.570312 79.601562 62.492188 79.738281 62.347656 C 79.878906 62.207031 79.957031 62.019531 79.957031 61.824219 L 79.957031 21.195312 C 79.957031 20.996094 79.878906 20.804688 79.738281 20.664062 C 79.597656 20.523438 79.40625 20.445312 79.207031 20.445312 Z M 79.207031 20.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.875 21.195312 L 73.164062 21.195312 L 73.164062 67.484375 L 67.875 67.484375 Z M 67.875 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 67.882812 21.203125 L 70.253906 21.203125 L 70.253906 67.492188 L 67.882812 67.492188 Z M 67.882812 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 67.875 21.195312 L 73.164062 21.195312 L 73.164062 31.074219 L 67.875 31.074219 Z M 67.875 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 67.882812 21.203125 L 70.253906 21.203125 L 70.253906 31.074219 L 67.882812 31.074219 Z M 67.882812 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 73.171875 21.195312 L 73.171875 21.195312 M 73.171875 21.195312 L 73.171875 67.5 L 67.875 67.5 L 67.875 21.195312 L 73.171875 21.195312 M 73.171875 20.445312 L 67.875 20.445312 C 67.460938 20.445312 67.125 20.78125 67.125 21.195312 L 67.125 67.5 C 67.125 67.699219 67.203125 67.890625 67.34375 68.03125 C 67.484375 68.171875 67.675781 68.25 67.875 68.25 L 73.171875 68.25 C 73.371094 68.25 73.5625 68.171875 73.703125 68.03125 C 73.84375 67.890625 73.921875 67.699219 73.921875 67.5 L 73.921875 21.195312 C 73.921875 20.996094 73.839844 20.804688 73.699219 20.664062 C 73.558594 20.523438 73.367188 20.445312 73.171875 20.445312 Z M 73.171875 21.945312 Z M 73.171875 21.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 61.835938 21.195312 L 67.125 21.195312 L 67.125 67.484375 L 61.835938 67.484375 Z M 61.835938 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 61.835938 21.203125 L 64.207031 21.203125 L 64.207031 67.492188 L 61.835938 67.492188 Z M 61.835938 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 61.835938 21.195312 L 67.125 21.195312 L 67.125 31.074219 L 61.835938 31.074219 Z M 61.835938 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 61.835938 21.203125 L 64.207031 21.203125 L 64.207031 31.074219 L 61.835938 31.074219 Z M 61.835938 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 67.125 21.195312 L 67.125 67.5 L 61.875 67.5 L 61.875 21.195312 L 67.125 21.195312 M 67.125 20.445312 L 61.875 20.445312 C 61.460938 20.445312 61.125 20.78125 61.125 21.195312 L 61.125 67.5 C 61.125 67.699219 61.203125 67.890625 61.34375 68.03125 C 61.484375 68.171875 61.675781 68.25 61.875 68.25 L 67.125 68.25 C 67.324219 68.25 67.515625 68.171875 67.65625 68.03125 C 67.796875 67.890625 67.875 67.699219 67.875 67.5 L 67.875 21.195312 C 67.875 20.996094 67.796875 20.804688 67.65625 20.664062 C 67.515625 20.523438 67.324219 20.445312 67.125 20.445312 Z M 67.125 20.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.792969 21.195312 L 61.082031 21.195312 L 61.082031 67.484375 L 55.792969 67.484375 Z M 55.792969 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 55.800781 21.203125 L 58.171875 21.203125 L 58.171875 67.492188 L 55.800781 67.492188 Z M 55.800781 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 55.792969 21.195312 L 61.082031 21.195312 L 61.082031 31.074219 L 55.792969 31.074219 Z M 55.792969 21.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 55.800781 21.203125 L 58.171875 21.203125 L 58.171875 31.074219 L 55.800781 31.074219 Z M 55.800781 21.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 61.085938 21.195312 L 61.085938 67.5 L 55.792969 67.5 L 55.792969 21.195312 L 61.089844 21.195312 M 61.089844 20.445312 L 55.792969 20.445312 C 55.378906 20.445312 55.042969 20.78125 55.042969 21.195312 L 55.042969 67.5 C 55.042969 67.699219 55.121094 67.890625 55.261719 68.03125 C 55.402344 68.171875 55.59375 68.25 55.792969 68.25 L 61.089844 68.25 L 61.085938 68.25 C 61.285156 68.25 61.472656 68.171875 61.613281 68.03125 C 61.753906 67.890625 61.835938 67.699219 61.835938 67.5 L 61.835938 21.195312 C 61.835938 20.996094 61.757812 20.804688 61.617188 20.664062 C 61.476562 20.523438 61.285156 20.445312 61.085938 20.445312 Z M 61.089844 20.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 85.253906 21.195312 L 85.253906 21.195312 M 85.253906 21.195312 L 85.253906 67.5 L 55.800781 67.5 L 55.800781 21.195312 L 85.261719 21.195312 M 69.375 31.074219 L 69.375 31.074219 M 85.253906 19.695312 L 55.792969 19.695312 C 54.964844 19.695312 54.292969 20.367188 54.292969 21.195312 L 54.292969 67.5 C 54.292969 67.898438 54.449219 68.28125 54.730469 68.5625 C 55.011719 68.84375 55.394531 69 55.792969 69 L 85.246094 69 C 85.644531 69 86.023438 68.84375 86.304688 68.5625 C 86.585938 68.28125 86.746094 67.898438 86.746094 67.5 L 86.746094 21.195312 C 86.746094 20.796875 86.585938 20.414062 86.304688 20.132812 C 86.023438 19.851562 85.644531 19.695312 85.246094 19.695312 Z M 85.253906 22.695312 Z M 85.253906 22.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 86.683594 71.324219 L 54.359375 71.324219 C 53.546875 71.324219 52.878906 70.675781 52.859375 69.863281 L 52.859375 34.289062 C 61.925781 44.039062 78.300781 44.210938 87.660156 34.730469 L 88.109375 34.289062 L 88.109375 69.863281 C 88.089844 70.648438 87.46875 71.285156 86.683594 71.324219 Z M 86.683594 71.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 88.148438 16.253906 L 88.148438 70.035156 C 88.148438 70.746094 87.570312 71.324219 86.859375 71.324219 L 54.1875 71.324219 C 53.476562 71.324219 52.898438 70.746094 52.898438 70.035156 L 52.898438 16.253906 L 88.148438 16.253906 M 88.148438 14.753906 L 52.898438 14.753906 C 52.070312 14.753906 51.398438 15.425781 51.398438 16.253906 L 51.398438 70.035156 C 51.402344 71.574219 52.648438 72.820312 54.1875 72.824219 L 86.859375 72.824219 C 88.398438 72.820312 89.644531 71.574219 89.648438 70.035156 L 89.648438 16.253906 C 89.648438 15.855469 89.488281 15.472656 89.207031 15.191406 C 88.925781 14.910156 88.546875 14.753906 88.148438 14.753906 Z M 88.148438 14.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 88.148438 34.289062 L 88.148438 69.863281 C 88.128906 70.675781 87.460938 71.324219 86.648438 71.324219 L 54.359375 71.324219 C 53.546875 71.324219 52.878906 70.675781 52.859375 69.863281 L 52.859375 34.289062 C 57.417969 38.957031 63.644531 41.625 70.167969 41.707031 C 76.691406 41.789062 82.984375 39.28125 87.660156 34.734375 L 88.109375 34.292969 M 88.109375 32.792969 L 88.109375 32.789062 C 87.707031 32.789062 87.320312 32.945312 87.039062 33.234375 L 86.597656 33.683594 L 86.59375 33.683594 C 82.207031 37.925781 76.316406 40.265625 70.210938 40.1875 C 64.105469 40.109375 58.277344 37.621094 54 33.261719 C 53.714844 32.957031 53.316406 32.789062 52.898438 32.789062 C 52.710938 32.789062 52.523438 32.824219 52.351562 32.894531 C 51.777344 33.121094 51.398438 33.671875 51.398438 34.289062 L 51.398438 69.863281 C 51.417969 71.503906 52.753906 72.824219 54.398438 72.824219 L 86.722656 72.824219 C 88.363281 72.824219 89.703125 71.503906 89.722656 69.863281 L 89.722656 34.289062 C 89.722656 33.683594 89.355469 33.132812 88.792969 32.902344 C 88.613281 32.824219 88.417969 32.789062 88.222656 32.789062 Z M 88.109375 32.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.148438 65.753906 L 52.898438 65.753906 L 52.898438 56.851562 L 70.523438 41.851562 L 88.148438 56.851562 Z M 88.148438 65.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 70.5 41.851562 L 88.125 56.851562 L 88.125 65.753906 L 52.875 65.753906 L 52.875 56.851562 L 70.5 41.851562 M 70.5 41.101562 C 70.320312 41.101562 70.148438 41.164062 70.011719 41.28125 L 52.417969 56.25 C 52.25 56.390625 52.148438 56.597656 52.148438 56.820312 L 52.148438 65.753906 C 52.148438 65.953125 52.226562 66.140625 52.367188 66.28125 C 52.507812 66.421875 52.699219 66.503906 52.898438 66.503906 L 88.148438 66.503906 C 88.347656 66.503906 88.539062 66.421875 88.679688 66.28125 C 88.820312 66.140625 88.898438 65.953125 88.898438 65.753906 L 88.898438 56.851562 C 88.894531 56.628906 88.796875 56.421875 88.628906 56.28125 L 71.011719 41.25 C 70.863281 41.140625 70.683594 41.085938 70.5 41.101562 Z M 70.5 41.101562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 52.898438 68.011719 L 52.898438 69.863281 C 52.917969 70.675781 53.582031 71.324219 54.398438 71.324219 L 86.722656 71.324219 C 87.535156 71.324219 88.203125 70.675781 88.222656 69.863281 L 88.222656 68.011719 Z M 52.898438 68.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 88.148438 68.011719 L 88.148438 69.863281 C 88.128906 70.675781 87.460938 71.324219 86.648438 71.324219 L 54.359375 71.324219 C 53.546875 71.324219 52.878906 70.675781 52.859375 69.863281 L 52.859375 68.011719 L 88.109375 68.011719 M 88.109375 67.261719 L 52.859375 67.261719 C 52.445312 67.261719 52.109375 67.597656 52.109375 68.011719 L 52.109375 69.863281 C 52.128906 71.089844 53.132812 72.074219 54.359375 72.074219 L 86.683594 72.074219 C 87.914062 72.074219 88.914062 71.089844 88.933594 69.863281 L 88.933594 68.011719 C 88.933594 67.8125 88.855469 67.621094 88.714844 67.480469 C 88.574219 67.339844 88.382812 67.261719 88.183594 67.261719 Z M 88.109375 67.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 70.648438 56.371094 L 70.5 55.785156 L 70.5 56.039062 L 70.148438 56.226562 L 70.074219 55.882812 L 69.660156 55.882812 L 69.808594 55.476562 L 69.539062 55.257812 L 69.539062 55.261719 C 69.691406 55.078125 69.9375 55.007812 70.164062 55.078125 C 70.359375 55.207031 70.601562 55.242188 70.828125 55.179688 C 71.054688 55.117188 71.242188 54.960938 71.347656 54.75 C 71.453125 54.609375 71.574219 54.480469 71.683594 54.34375 L 71.683594 54.269531 L 71.21875 54.488281 C 71.203125 54.339844 71.160156 54.195312 71.101562 54.058594 C 70.808594 53.644531 70.703125 53.128906 70.808594 52.636719 C 70.835938 52.503906 70.789062 52.371094 70.6875 52.28125 C 70.378906 51.980469 70.011719 51.75 69.609375 51.609375 C 69.511719 51.570312 69.410156 51.558594 69.308594 51.5625 C 69.1875 51.597656 69.074219 51.648438 68.960938 51.703125 L 69.125 52.027344 C 68.984375 52.207031 68.855469 52.230469 68.488281 52.109375 L 68.203125 52.355469 L 68.277344 52.355469 L 68.230469 52.957031 L 67.789062 52.785156 L 67.792969 52.785156 C 67.738281 52.863281 67.675781 52.933594 67.605469 52.996094 C 67.542969 53.046875 67.460938 53.078125 67.378906 53.085938 C 67.28125 53.097656 67.179688 53.097656 67.078125 53.085938 C 67.027344 52.839844 67.160156 52.59375 67.394531 52.507812 L 67.320312 52.457031 L 67.027344 52.675781 L 66.742188 52.519531 C 66.839844 52.210938 66.921875 52.167969 67.3125 52.160156 L 67.011719 52.070312 L 66.855469 51.808594 L 66.855469 51.800781 C 67.019531 51.640625 67.285156 51.640625 67.449219 51.800781 C 67.523438 51.890625 67.65625 51.890625 67.734375 51.800781 C 67.9375 51.597656 68.140625 51.410156 68.328125 51.230469 L 67.714844 50.691406 L 67.710938 50.691406 C 68.148438 50.496094 68.519531 50.183594 68.789062 49.785156 C 69.109375 49.433594 69.554688 49.222656 70.027344 49.191406 C 70.394531 49.191406 70.53125 49.035156 70.574219 48.742188 C 70.347656 48.703125 70.339844 48.742188 70.191406 48.96875 C 69.890625 48.730469 69.875 48.660156 69.996094 48.457031 C 70.183594 48.457031 70.332031 48.457031 70.417969 48.359375 C 70.5 48.261719 70.417969 47.953125 70.28125 47.886719 C 70.144531 47.820312 70.035156 47.933594 69.921875 48.113281 L 69.703125 47.589844 L 69.996094 47.507812 L 69.660156 47.507812 L 69.660156 47.503906 C 69.742188 47.453125 69.832031 47.414062 69.921875 47.386719 C 70.238281 47.320312 70.558594 47.273438 70.882812 47.25 C 71.136719 47.207031 71.398438 47.269531 71.609375 47.421875 C 71.820312 47.574219 71.960938 47.804688 72 48.058594 L 72.179688 48.660156 L 72.089844 48.660156 L 72 49.808594 L 71.878906 49.808594 L 71.25 50.753906 L 72.398438 51.945312 C 72.519531 52.097656 72.652344 52.238281 72.796875 52.371094 C 72.941406 52.503906 73.105469 52.609375 73.28125 52.6875 C 73.410156 52.75 73.558594 52.746094 73.6875 52.683594 C 73.8125 52.617188 73.902344 52.5 73.925781 52.359375 C 73.953125 52.21875 73.914062 52.078125 73.820312 51.96875 C 73.726562 51.863281 73.589844 51.808594 73.449219 51.816406 C 73.367188 51.816406 73.320312 51.996094 73.269531 52.09375 C 73.21875 52.191406 73.269531 52.152344 73.269531 52.183594 C 72.992188 52.042969 72.96875 51.867188 73.1875 51.480469 C 72.65625 51.527344 72.113281 51.570312 71.933594 50.925781 C 71.835938 50.59375 71.925781 50.234375 72.164062 49.988281 C 72.289062 50.160156 72.328125 50.375 72.269531 50.578125 C 72.171875 50.871094 72.390625 51.082031 72.75 51.101562 L 73.296875 51.101562 L 73.296875 51.105469 C 73.191406 50.867188 73 50.675781 72.765625 50.566406 C 72.375 50.339844 72.160156 49.902344 72.222656 49.457031 C 72.285156 49.011719 72.613281 48.648438 73.050781 48.539062 C 73.121094 48.527344 73.191406 48.527344 73.261719 48.539062 C 73.488281 48.539062 73.613281 48.433594 73.636719 48.171875 C 73.898438 48.320312 74.140625 48.457031 74.386719 48.605469 C 74.386719 48.605469 74.4375 48.800781 74.386719 48.824219 C 74.160156 48.980469 73.921875 49.117188 73.6875 49.257812 C 73.523438 48.921875 73.296875 48.859375 73.003906 49.023438 L 73.003906 49.027344 C 72.796875 49.128906 72.65625 49.332031 72.628906 49.5625 C 72.605469 49.792969 72.699219 50.019531 72.878906 50.167969 C 73.019531 50.304688 73.195312 50.40625 73.328125 50.542969 C 73.464844 50.679688 73.582031 50.835938 73.71875 50.984375 C 74.019531 50.796875 74.152344 50.8125 74.339844 51.066406 L 74.234375 51.066406 C 73.988281 51.066406 73.90625 51.230469 74.015625 51.449219 C 74.121094 51.632812 74.210938 51.824219 74.28125 52.019531 C 74.382812 52.371094 74.238281 52.75 73.925781 52.941406 C 73.621094 53.167969 73.199219 53.167969 72.890625 52.941406 C 72.714844 52.820312 72.542969 52.683594 72.382812 52.539062 C 72.050781 52.726562 71.882812 53.113281 71.976562 53.484375 C 72.082031 53.867188 72.328125 53.941406 72.605469 53.664062 L 72.609375 53.664062 C 72.699219 53.945312 72.652344 54.257812 72.480469 54.503906 C 72.292969 54.804688 71.976562 55.027344 72.023438 55.449219 C 71.722656 55.351562 71.640625 55.382812 71.535156 55.644531 C 71.429688 55.90625 71.265625 56.140625 70.921875 56.117188 C 70.871094 56.117188 70.808594 56.253906 70.757812 56.320312 Z M 70.648438 56.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 67.84375 54.425781 C 67.925781 54.097656 67.84375 53.960938 67.625 53.894531 C 67.722656 53.722656 67.894531 53.660156 68.21875 53.648438 L 67.964844 53.582031 L 67.964844 53.320312 C 68.175781 53.320312 68.390625 53.320312 68.542969 53.566406 C 68.742188 53.796875 69.042969 53.90625 69.34375 53.859375 C 69.441406 53.859375 69.539062 53.859375 69.679688 53.859375 L 69.542969 53.695312 C 69.496094 53.636719 69.445312 53.574219 69.402344 53.507812 C 69.230469 53.246094 69.238281 52.863281 68.890625 52.710938 C 68.890625 52.710938 68.890625 52.644531 68.839844 52.570312 C 69.148438 52.570312 69.296875 52.414062 69.476562 52.234375 L 69.480469 52.230469 C 69.660156 51.996094 69.992188 51.949219 70.230469 52.125 C 70.273438 52.167969 70.308594 52.222656 70.328125 52.28125 C 70.378906 52.359375 70.433594 52.433594 70.5 52.5 C 70.703125 52.679688 70.710938 52.679688 70.679688 52.914062 C 70.523438 52.914062 70.34375 52.914062 70.246094 52.996094 C 70.117188 53.136719 70.117188 53.351562 70.246094 53.488281 C 70.410156 53.742188 70.613281 53.96875 70.824219 54.238281 C 70.683594 54.382812 70.496094 54.460938 70.296875 54.464844 C 69.996094 54.433594 69.691406 54.523438 69.457031 54.71875 C 69.277344 54.410156 69.230469 54.417969 68.96875 54.605469 L 68.96875 54.609375 C 68.835938 54.6875 68.6875 54.75 68.535156 54.789062 L 68.535156 54.722656 L 68.414062 54.886719 L 68.25 54.886719 L 68.308594 54.265625 L 68.179688 54.519531 Z M 67.84375 54.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 67.066406 49.5 C 66.765625 49.433594 66.742188 49.15625 66.691406 48.890625 C 66.914062 48.808594 67.167969 48.875 67.320312 49.066406 L 67.101562 48.488281 C 67.371094 48.5625 67.632812 48.609375 67.679688 48.921875 L 67.777344 48.375 C 67.964844 48.570312 68.101562 48.734375 68.015625 48.96875 C 67.941406 49.160156 68.003906 49.382812 68.167969 49.507812 L 68.582031 49.90625 L 68.070312 50.476562 L 67.605469 49.914062 L 66.90625 50.109375 Z M 67.066406 49.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 71.453125 47.003906 C 70.921875 47.003906 70.410156 47.003906 69.90625 47.003906 C 69.757812 47.003906 69.726562 46.945312 69.710938 46.808594 C 69.710938 46.53125 69.644531 46.261719 69.605469 45.9375 L 70.011719 46.238281 C 69.960938 46.308594 69.921875 46.390625 69.898438 46.476562 C 69.898438 46.476562 69.972656 46.550781 70.011719 46.597656 C 70.117188 46.449219 70.347656 46.71875 70.402344 46.476562 C 70.402344 46.425781 70.328125 46.339844 70.28125 46.265625 L 70.582031 45.800781 L 70.859375 46.234375 L 70.792969 46.535156 L 71.25 46.539062 L 71.175781 46.214844 L 71.566406 45.929688 Z M 71.453125 47.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 73.597656 50.542969 C 73.597656 50.214844 73.386719 50.160156 73.132812 50.175781 C 72.878906 50.191406 72.765625 50.109375 72.683594 49.792969 C 72.839844 49.792969 73 49.792969 73.148438 49.792969 C 73.296875 49.792969 73.570312 49.746094 73.589844 49.46875 C 73.84375 49.609375 74.085938 49.730469 74.339844 49.875 C 74.339844 49.875 74.386719 50.070312 74.339844 50.09375 C 74.101562 50.25 73.859375 50.386719 73.597656 50.542969 Z M 73.597656 50.542969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 68.820312 48 C 68.714844 48.359375 68.820312 48.496094 69.1875 48.414062 C 69.398438 48.367188 69.609375 48.292969 69.816406 48.242188 L 69.816406 48.238281 C 69.921875 48.234375 70.027344 48.234375 70.132812 48.238281 C 69.914062 48.386719 69.683594 48.519531 69.441406 48.628906 C 69.230469 48.71875 69.003906 48.769531 68.773438 48.78125 C 68.667969 48.777344 68.566406 48.730469 68.496094 48.652344 C 68.425781 48.574219 68.390625 48.464844 68.398438 48.359375 C 68.414062 48.089844 68.550781 48 68.820312 48 Z M 68.820312 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 82.199219 60.808594 L 58.84375 60.808594 C 58.429688 60.808594 58.09375 60.472656 58.09375 60.058594 C 58.09375 59.644531 58.429688 59.308594 58.84375 59.308594 L 82.199219 59.308594 C 82.613281 59.308594 82.949219 59.644531 82.949219 60.058594 C 82.949219 60.472656 82.613281 60.808594 82.199219 60.808594 Z M 82.199219 60.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 78.074219 63.433594 L 63 63.433594 C 62.792969 63.433594 62.625 63.265625 62.625 63.058594 C 62.625 62.851562 62.792969 62.683594 63 62.683594 L 78.074219 62.683594 C 78.28125 62.683594 78.449219 62.851562 78.449219 63.058594 C 78.449219 63.265625 78.28125 63.433594 78.074219 63.433594 Z M 78.074219 63.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 36.988281 39.601562 C 41.167969 39.601562 45.171875 41.257812 48.125 44.214844 C 51.082031 47.167969 52.738281 51.171875 52.738281 55.351562 C 52.738281 59.527344 51.082031 63.535156 48.125 66.488281 C 45.171875 69.441406 41.167969 71.101562 36.988281 71.101562 C 32.8125 71.101562 28.808594 69.441406 25.851562 66.488281 C 22.898438 63.535156 21.238281 59.527344 21.238281 55.351562 C 21.238281 51.171875 22.898438 47.167969 25.851562 44.214844 C 28.808594 41.257812 32.8125 39.601562 36.988281 39.601562 M 36.988281 38.101562 C 32.414062 38.101562 28.027344 39.917969 24.792969 43.152344 C 21.558594 46.386719 19.738281 50.773438 19.738281 55.351562 C 19.738281 59.925781 21.558594 64.3125 24.792969 67.546875 C 28.027344 70.78125 32.414062 72.601562 36.988281 72.601562 C 41.566406 72.601562 45.953125 70.78125 49.1875 67.546875 C 52.421875 64.3125 54.238281 59.925781 54.238281 55.351562 C 54.238281 50.773438 52.421875 46.386719 49.1875 43.152344 C 45.953125 39.917969 41.566406 38.101562 36.988281 38.101562 Z M 36.988281 38.101562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,56.862745%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 52.738281 55.351562 C 52.738281 64.046875 45.6875 71.101562 36.988281 71.101562 C 28.292969 71.101562 21.238281 64.046875 21.238281 55.351562 C 21.238281 46.652344 28.292969 39.601562 36.988281 39.601562 C 45.6875 39.601562 52.738281 46.652344 52.738281 55.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(51.764706%,51.764706%,51.764706%)",
      fillOpacity: 1
    },
    d: "M 52.738281 55.351562 C 52.738281 64.046875 45.6875 71.101562 36.988281 71.101562 C 28.292969 71.101562 21.238281 64.046875 21.238281 55.351562 C 21.238281 46.652344 28.292969 39.601562 36.988281 39.601562 C 45.6875 39.601562 52.738281 46.652344 52.738281 55.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,81.176471%,81.176471%)",
      fillOpacity: 1
    },
    d: "M 51.238281 48.667969 C 49.320312 44.472656 45.660156 41.332031 41.222656 40.070312 C 36.789062 38.808594 32.019531 39.558594 28.183594 42.117188 C 24.347656 44.671875 21.820312 48.785156 21.277344 53.363281 C 20.734375 57.945312 22.226562 62.53125 25.359375 65.917969 C 31.125 68.289062 37.699219 67.640625 42.890625 64.179688 C 48.078125 60.71875 51.210938 54.90625 51.238281 48.667969 Z M 51.238281 48.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.470588%,56.862745%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 50.863281 55.351562 C 50.863281 63.011719 44.652344 69.226562 36.988281 69.226562 C 29.328125 69.226562 23.113281 63.011719 23.113281 55.351562 C 23.113281 47.6875 29.328125 41.476562 36.988281 41.476562 C 44.652344 41.476562 50.863281 47.6875 50.863281 55.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 36.988281 41.476562 C 42.601562 41.476562 47.660156 44.855469 49.808594 50.039062 C 51.957031 55.226562 50.769531 61.191406 46.800781 65.160156 C 42.832031 69.128906 36.863281 70.316406 31.679688 68.167969 C 26.496094 66.019531 23.113281 60.960938 23.113281 55.351562 C 23.113281 47.6875 29.328125 41.476562 36.988281 41.476562 M 36.988281 40.726562 C 33.109375 40.726562 29.390625 42.265625 26.648438 45.007812 C 23.90625 47.75 22.363281 51.472656 22.363281 55.351562 C 22.363281 59.230469 23.90625 62.949219 26.648438 65.691406 C 29.390625 68.433594 33.109375 69.976562 36.988281 69.976562 C 40.867188 69.976562 44.589844 68.433594 47.332031 65.691406 C 50.074219 62.949219 51.613281 59.230469 51.613281 55.351562 C 51.609375 51.472656 50.070312 47.753906 47.328125 45.011719 C 44.585938 42.269531 40.867188 40.730469 36.988281 40.726562 Z M 36.988281 40.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.980392%,76.862745%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 36.988281 41.476562 C 29.328125 41.476562 23.113281 47.6875 23.113281 55.351562 C 23.101562 57.648438 23.664062 59.910156 24.75 61.933594 C 29.632812 66.765625 37.316406 67.292969 42.816406 63.179688 C 48.320312 59.066406 49.980469 51.542969 46.726562 45.496094 C 44.136719 42.921875 40.636719 41.476562 36.988281 41.476562 Z M 36.988281 41.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 29.363281 56.0625 C 28.949219 56.121094 28.5625 55.835938 28.503906 55.421875 C 28.445312 55.007812 28.730469 54.621094 29.144531 54.5625 L 43.085938 50.332031 C 43.492188 50.21875 43.910156 50.453125 44.023438 50.859375 C 44.140625 51.261719 43.902344 51.679688 43.5 51.796875 L 29.578125 56.023438 C 29.511719 56.050781 29.4375 56.0625 29.363281 56.0625 Z M 29.363281 56.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 33.136719 59.617188 C 32.722656 59.675781 32.335938 59.390625 32.277344 58.976562 C 32.214844 58.5625 32.503906 58.175781 32.917969 58.117188 L 41.917969 55.386719 C 42.113281 55.316406 42.328125 55.324219 42.511719 55.417969 C 42.699219 55.507812 42.835938 55.675781 42.898438 55.871094 C 42.957031 56.070312 42.933594 56.285156 42.828125 56.464844 C 42.726562 56.644531 42.554688 56.773438 42.351562 56.820312 L 33.351562 59.558594 C 33.285156 59.589844 33.210938 59.609375 33.136719 59.617188 Z M 33.136719 59.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 45.675781 61.574219 C 45.601562 61.578125 45.527344 61.558594 45.464844 61.515625 C 45.292969 61.398438 45.246094 61.164062 45.359375 60.988281 C 48.304688 56.621094 47.398438 50.722656 43.273438 47.445312 C 43.1875 47.386719 43.128906 47.292969 43.113281 47.191406 C 43.097656 47.085938 43.125 46.980469 43.1875 46.898438 C 43.253906 46.816406 43.351562 46.765625 43.457031 46.757812 C 43.5625 46.75 43.664062 46.789062 43.738281 46.859375 C 48.171875 50.378906 49.152344 56.714844 45.988281 61.410156 C 45.921875 61.515625 45.800781 61.578125 45.675781 61.574219 Z M 45.675781 61.574219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.5 61.84375 C 28.378906 61.84375 28.265625 61.785156 28.191406 61.6875 C 24.816406 56.988281 25.714844 50.46875 30.238281 46.859375 C 30.316406 46.796875 30.417969 46.765625 30.515625 46.777344 C 30.613281 46.789062 30.703125 46.839844 30.765625 46.921875 C 30.828125 46.996094 30.859375 47.097656 30.847656 47.195312 C 30.835938 47.292969 30.785156 47.382812 30.703125 47.445312 C 26.496094 50.804688 25.660156 56.871094 28.800781 61.246094 C 28.917969 61.414062 28.882812 61.644531 28.71875 61.769531 C 28.65625 61.820312 28.578125 61.84375 28.5 61.84375 Z M 28.5 61.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 39.996094 48.203125 L 39.574219 48.203125 L 39.578125 48.203125 C 39.519531 48.207031 39.464844 48.179688 39.425781 48.136719 L 38.363281 46.949219 C 38.296875 46.875 38.289062 46.875 38.214844 46.949219 L 36.75 48 L 36.554688 48.148438 C 36.515625 48.179688 36.46875 48.195312 36.421875 48.195312 L 35.519531 48.195312 C 35.464844 48.199219 35.417969 48.167969 35.390625 48.121094 L 34.640625 46.945312 C 34.574219 46.839844 34.574219 46.839844 34.46875 46.90625 L 33.492188 47.515625 L 33.425781 47.5625 C 33.386719 47.5625 33.425781 47.5625 33.425781 47.621094 L 33.613281 47.847656 L 33.613281 47.84375 C 33.65625 47.871094 33.65625 47.933594 33.613281 47.960938 L 33.507812 48.117188 C 33.457031 48.183594 33.457031 48.183594 33.378906 48.117188 L 32.832031 47.792969 L 32.585938 47.636719 C 32.511719 47.597656 32.511719 47.589844 32.535156 47.507812 C 32.65625 47.125 32.773438 46.757812 32.902344 46.367188 L 32.902344 46.371094 C 33.070312 45.84375 33.269531 45.328125 33.503906 44.828125 C 33.574219 44.679688 33.660156 44.535156 33.75 44.398438 C 33.933594 44.097656 34.234375 43.886719 34.582031 43.824219 C 34.910156 43.75 35.246094 43.714844 35.578125 43.726562 L 36.636719 43.726562 L 37.265625 43.679688 C 37.546875 43.644531 37.828125 43.644531 38.109375 43.679688 C 38.316406 43.722656 38.519531 43.792969 38.707031 43.890625 C 39.164062 44.109375 39.621094 44.316406 40.070312 44.542969 C 40.273438 44.648438 40.46875 44.769531 40.664062 44.871094 C 40.726562 44.90625 40.773438 44.960938 40.792969 45.03125 C 40.792969 45.144531 40.875 45.257812 40.914062 45.375 C 40.933594 45.421875 40.964844 45.457031 41.011719 45.480469 L 41.425781 45.707031 C 41.472656 45.707031 41.476562 45.753906 41.425781 45.796875 C 41.375 45.84375 41.214844 46.097656 41.117188 46.253906 L 41.113281 46.253906 C 41.089844 46.289062 41.046875 46.308594 41.003906 46.304688 L 40.253906 46.253906 L 39.632812 46.253906 C 39.632812 46.253906 39.582031 46.253906 39.582031 46.304688 L 39.582031 47.054688 L 39.578125 47.054688 C 39.578125 47.09375 39.597656 47.125 39.621094 47.152344 L 40.09375 47.789062 C 40.121094 47.824219 40.15625 47.851562 40.199219 47.859375 L 40.445312 47.917969 C 40.496094 47.917969 40.519531 47.917969 40.511719 48.007812 L 40.511719 48.136719 C 40.511719 48.226562 40.511719 48.234375 40.421875 48.234375 Z M 36.375 46.5 L 35.941406 46.5 C 35.867188 46.5 35.867188 46.5 35.867188 46.574219 L 35.867188 47.324219 L 35.863281 47.324219 C 35.859375 47.351562 35.859375 47.378906 35.863281 47.40625 L 36.179688 47.75 C 36.179688 47.75 36.230469 47.75 36.253906 47.75 L 36.816406 46.59375 C 36.816406 46.535156 36.816406 46.535156 36.769531 46.527344 Z M 36.375 46.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 36.988281 63.914062 L 37.546875 65.039062 L 38.796875 65.226562 L 37.890625 66.105469 L 38.109375 67.351562 L 36.988281 66.757812 L 35.871094 67.351562 L 36.082031 66.105469 L 35.183594 65.226562 L 36.425781 65.039062 Z M 36.988281 63.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 43.140625 61.957031 L 43.605469 62.886719 L 44.632812 63.039062 L 43.890625 63.765625 L 44.0625 64.785156 L 43.140625 64.304688 L 42.226562 64.785156 L 42.398438 63.765625 L 41.65625 63.039062 L 42.683594 62.886719 Z M 43.140625 61.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 30.832031 61.957031 L 31.289062 62.886719 L 32.316406 63.039062 L 31.574219 63.765625 L 31.753906 64.785156 L 30.832031 64.304688 L 29.910156 64.785156 L 30.089844 63.765625 L 29.347656 63.039062 L 30.375 62.886719 Z M 30.832031 61.957031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.705882%,30.980392%,6.27451%)",
      fillOpacity: 1
    },
    d: "M 195.699219 23.390625 C 191.246094 19.011719 185.015625 16.945312 178.828125 17.804688 C 172.644531 18.660156 167.207031 22.34375 164.117188 27.769531 C 161.027344 33.195312 160.632812 39.75 163.050781 45.507812 C 165.46875 51.261719 170.425781 55.570312 176.460938 57.164062 C 182.5 58.753906 188.933594 57.453125 193.878906 53.636719 C 198.820312 49.820312 201.710938 43.925781 201.699219 37.679688 C 201.695312 32.304688 199.53125 27.160156 195.699219 23.390625 Z M 166.675781 37.679688 L 166.671875 37.679688 C 166.675781 34.042969 168.011719 30.53125 170.429688 27.8125 C 172.84375 25.097656 176.175781 23.359375 179.789062 22.933594 C 183.398438 22.507812 187.042969 23.417969 190.027344 25.5 L 169.34375 46.171875 C 167.601562 43.679688 166.667969 40.71875 166.671875 37.679688 Z M 181.546875 52.550781 C 178.507812 52.554688 175.542969 51.625 173.054688 49.882812 L 193.746094 29.199219 C 195.828125 32.183594 196.742188 35.828125 196.3125 39.445312 C 195.886719 43.058594 194.144531 46.390625 191.421875 48.808594 C 188.699219 51.222656 185.183594 52.554688 181.546875 52.550781 Z M 181.546875 52.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,27.843137%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 199.042969 27.75 C 198.125 26.15625 197 24.691406 195.699219 23.390625 L 195.542969 23.449219 L 167.203125 51.796875 C 171.8125 56.46875 178.410156 58.601562 184.878906 57.507812 C 191.351562 56.417969 196.882812 52.238281 199.703125 46.3125 C 202.523438 40.386719 202.277344 33.460938 199.042969 27.75 Z M 181.546875 52.550781 C 178.507812 52.554688 175.542969 51.625 173.054688 49.882812 L 193.746094 29.199219 C 194.414062 30.15625 194.96875 31.1875 195.398438 32.273438 C 197.171875 36.84375 196.574219 42 193.804688 46.046875 C 191.035156 50.09375 186.449219 52.519531 181.546875 52.523438 Z M 181.546875 52.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 181.546875 17.558594 C 186.882812 17.558594 192 19.675781 195.773438 23.453125 C 199.546875 27.226562 201.667969 32.34375 201.667969 37.679688 C 201.667969 43.015625 199.546875 48.136719 195.773438 51.910156 C 192 55.683594 186.882812 57.800781 181.546875 57.800781 C 176.207031 57.800781 171.089844 55.683594 167.316406 51.910156 C 163.542969 48.136719 161.421875 43.015625 161.421875 37.679688 C 161.402344 32.335938 163.515625 27.207031 167.292969 23.429688 C 171.070312 19.652344 176.203125 17.539062 181.546875 17.558594 M 169.34375 46.171875 L 190.027344 25.5 C 186.179688 22.8125 181.292969 22.101562 176.839844 23.578125 C 172.386719 25.058594 168.894531 28.550781 167.417969 33.003906 C 165.941406 37.457031 166.65625 42.347656 169.34375 46.191406 M 181.546875 52.574219 C 185.183594 52.578125 188.699219 51.246094 191.421875 48.828125 C 194.144531 46.414062 195.886719 43.082031 196.3125 39.46875 C 196.742188 35.851562 195.828125 32.207031 193.746094 29.21875 L 173.054688 49.882812 C 175.542969 51.625 178.507812 52.554688 181.546875 52.550781 M 181.546875 16.054688 L 181.546875 16.058594 C 174.804688 16.046875 168.445312 19.179688 164.34375 24.523438 C 160.238281 29.867188 158.855469 36.820312 160.605469 43.328125 C 162.355469 49.835938 167.035156 55.160156 173.265625 57.726562 C 179.496094 60.296875 186.566406 59.816406 192.394531 56.433594 C 198.21875 53.046875 202.140625 47.140625 202.992188 40.457031 C 203.847656 33.773438 201.542969 27.070312 196.753906 22.328125 C 192.707031 18.316406 187.242188 16.066406 181.546875 16.058594 Z M 169.636719 43.753906 C 166.976562 38.589844 167.957031 32.296875 172.066406 28.1875 C 176.175781 24.078125 182.46875 23.09375 187.636719 25.753906 Z M 175.5 49.589844 L 193.5 31.589844 C 194.464844 33.46875 194.964844 35.546875 194.960938 37.65625 C 194.976562 42.320312 192.558594 46.652344 188.582031 49.089844 C 184.609375 51.527344 179.648438 51.71875 175.5 49.589844 Z M 175.5 49.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 179.941406 33.554688 L 171.203125 26.671875 L 168.414062 30.203125 L 176.738281 36.757812 Z M 179.941406 33.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 186.351562 38.601562 L 183.148438 41.8125 L 191.886719 48.699219 L 194.675781 45.15625 Z M 186.351562 38.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 178.171875 35.316406 L 169.664062 28.621094 L 168.421875 30.203125 L 176.738281 36.757812 Z M 178.171875 35.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 184.582031 40.371094 L 183.148438 41.8125 L 191.894531 48.699219 L 193.140625 47.113281 Z M 184.582031 40.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,76.470588%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 168.414062 30.199219 L 171.199219 26.664062 L 176.207031 30.609375 L 173.421875 34.144531 Z M 168.414062 30.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 168.421875 30.203125 L 169.671875 28.617188 L 174.679688 32.5625 L 173.429688 34.148438 Z M 168.421875 30.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 176.738281 36.75 L 168.414062 30.195312 L 171.203125 26.664062 L 179.941406 33.550781 L 181.007812 32.476562 L 172.125 25.5 C 171.8125 25.253906 171.414062 25.140625 171.019531 25.1875 C 170.625 25.234375 170.265625 25.433594 170.015625 25.746094 L 167.25 29.25 C 167.003906 29.5625 166.894531 29.960938 166.941406 30.355469 C 166.988281 30.75 167.191406 31.113281 167.503906 31.359375 L 175.679688 37.800781 Z M 176.738281 36.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 196.164062 45 C 196.140625 44.796875 196.074219 44.597656 195.96875 44.421875 C 195.875 44.257812 195.75 44.113281 195.601562 43.996094 L 187.425781 37.554688 L 186.351562 38.621094 L 194.675781 45.175781 L 191.886719 48.714844 L 183.148438 41.8125 L 182.082031 42.878906 L 190.960938 49.875 L 190.964844 49.875 C 191.613281 50.382812 192.550781 50.273438 193.066406 49.628906 L 195.855469 46.089844 L 195.855469 46.085938 C 196.09375 45.777344 196.207031 45.390625 196.164062 45 Z M 196.164062 45 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllTobacco);
export default __webpack_public_path__ + "static/media/ill_tobacco.1aa04b25bc8225175d2a112a59df7688.svg";
export { ForwardRef as ReactComponent };